import { TooltipProps } from "antd";
import { StyledTooltip, CustomTooltipStyle } from "./atom";
import { PropsWithChildren } from "react";

export type RenderbusTooltipProps = PropsWithChildren<
  TooltipProps<any> & {
    title: string | JSX.Element;
    tooltipText: string | JSX.Element;
    color?: string;
    getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
    direction?: string;
    className?: string;
    childrenElement?: Function; // 自定义内容，优先级比tooltipText高
    trigger?: boolean;
    black?: boolean;
    triggerBody?: ParentNode; // table遮挡问题
  }
>;
export interface TooltipsProps {}

export function Tooltip({
  title,
  tooltipText,
  color,
  direction,
  className,
  childrenElement,
  children,
  trigger = true,
  black = false,
  triggerBody,
  ...props
}: RenderbusTooltipProps) {
  return (
    <StyledTooltip
      className={`renderbus-ui--tooltip ${className}`}
      title={trigger && title}
      color={black ? "black" : color || "#fff"}
      getPopupContainer={(triggerNode) => triggerBody || triggerNode.parentNode}
      placement={direction || "top"}
      {...props}
    >
      {children ? children : tooltipText}
      <CustomTooltipStyle />
    </StyledTooltip>
  );
}
